<template>
    <div>
        <div class="row">

        </div>
        <div class="row">
            <div class="col-6">
                <b-form-group :label="$t('Payment amount')">
                    <money-field
                        :autofocus="true"
                        class="form-control-lg text-center"
                        v-model="company_data.data.amount"
                    ></money-field>
                </b-form-group>
            </div>
            <div class="col-6">
                <b-form-group :label="$t('Payment method') + '*'">
                    <b-form-select
                        class="p-2"
                        :options="company_data.paymentMethods"
                        v-model="company_data.data.paymentMethod"
                        :state="validation(company_data.data.paymentMethod)"
                        size="lg"
                    ></b-form-select>
                </b-form-group>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <b-form-group :label="$t('Note')">
                    <b-form-textarea
                        rows="3"
                        max-rows="8"
                        v-model="company_data.data.note"></b-form-textarea>
                </b-form-group>
            </div>
        </div>
    </div>
</template>

<script>
import TeamSelect from "@/components/TeamSelect";
import MoneyField from "@/components/MoneyField.vue";
import CustomSwitch from "@/components/CustomSwitch";

import DateInput from "@/components/DateInput";
import DatePicker from "@/components/DatePicker";

export default {
    name: "CompanyExpenses",
    props: ['company_data'],
    components: {
        TeamSelect,
        MoneyField,
        CustomSwitch,
        DateInput,
        DatePicker
    },
    data() {
        return {};
    },

    methods: {
        validation(field) {
            if (this.errors && this.errors[field]) return false;
            else return null;
        },
    },
};
</script>
